import { connect } from 'react-redux'
import UI from './UI'
import { push } from 'connected-react-router'
import { decorateUrl } from 'components/common/UTMscript'
import { AlgeriaId, billingCycleId, OnBoardingStateEnum, ProfileTypes, UserRoles } from 'constants/'
import { setTrialState } from 'components/Profile/store'
import { initOnboarding } from 'pages/OnBoardingNext/store'

const mapStateToProp = ({ identity, user, referential, marketing }) => ({
  isConnected: identity.isConnected,
  photo: user?.Photo,
  genderTypeId: user?.GenderTypeId,
  familyName: identity?.user?.family_name,
  givenName: identity?.user?.given_name,
  activeSubscription: user?.Subscription?.IsActive,
  profileType: user?.ProfileType ? ProfileTypes[referential?.ProfileTypes[user.ProfileType]] : null,
  isFrance: referential.IsFrance,
  isElligableForTrial: user.isElligableForTrial,
  topBarOpen: marketing.topBarOpen,
  isB2bUser: identity?.user?.role?.includes(String(referential.UserRoles[UserRoles.OrganizationLearner])) && user?.Subscription?.SubscriptionCycleType === billingCycleId.license,
  AutoRenew: user.Subscription.AutoRenew,
  isAlgeria: referential?.CountryDetails?.Id === AlgeriaId
})

const mapDispatchToProps = (dispatch) => ({
  startTrialOnboarding: () => dispatch(initOnboarding(OnBoardingStateEnum.Start)),
  setTrialState: (data) => dispatch(setTrialState(data)),
  goToLink: (url) => dispatch(push(decorateUrl(url)))
})

export default connect(mapStateToProp, mapDispatchToProps)(UI)
